'use client'

import { FC } from 'react'
import tryggehandel from '#/src/images/tryggehandel.webp'
import useAppConfig from '#/src/custom/hooks/useAppConfig'
import { CustomLocale } from '#/src/i18n'
import { Box } from '@chakra-ui/react'
import { GrandImage } from 'ui'
import { FooterStandard, FooterStandardProps } from 'storefront-modules/layout/footer'

type IFooter = Pick<FooterStandardProps, 'footerItems' | 'logo' | 'socialMediaItems'> & {
  locale: CustomLocale['locale']
}

const CustomFooter: FC<IFooter> = ({ logo, footerItems, socialMediaItems }) => {
  const config = useAppConfig()

  return (
    <FooterStandard
      logo={logo}
      footerItems={footerItems}
      socialMediaItems={socialMediaItems}
      paymentProviderName={config.paymentProviderConfig?.providerName}
      paymentMethodLogos={config.paymentMethodLogos}
      maxColumns={config.footerConfig?.maxColumns}
      socialMediasAfterAddon={
        <Box>
          <GrandImage alt="Tryggehandel" height={95} src={tryggehandel} width={95} />
        </Box>
      }
    />
  )
}

export default CustomFooter
